import { useState } from 'react';

export default function Base64Tool() {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [error, setError] = useState('');

    const encode = () => {
        try {
            const encoded = btoa(input);
            setOutput(encoded);
            setError('');
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Encoding failed');
            setOutput('');
        }
    };

    const decode = () => {
        try {
            const decoded = atob(input);
            setOutput(decoded);
            setError('');
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Decoding failed - invalid Base64');
            setOutput('');
        }
    };

    const clearAll = () => {
        setInput('');
        setOutput('');
        setError('');
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(output);
            alert('Copied to clipboard!');
        } catch (e) {
            alert('Failed to copy');
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-2">Base64 Encoder/Decoder</h1>
            <p className="text-gray-600 mb-6">Encode and decode Base64 strings</p>

            <div className="space-y-6">
                <div>
                    <div className="flex justify-between items-center mb-2">
                        <label className="font-medium">Input</label>
                        <div className="space-x-2">
                            <button onClick={encode} className="btn-primary">
                                Encode
                            </button>
                            <button onClick={decode} className="btn-primary">
                                Decode
                            </button>
                            <button onClick={clearAll} className="btn-secondary">
                                Clear
                            </button>
                        </div>
                    </div>
                    <textarea
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Enter text to encode or Base64 to decode..."
                        className="w-full h-48 p-4 border border-gray-300 rounded-lg font-mono text-sm"
                    />
                </div>

                <div>
                    <div className="flex justify-between items-center mb-2">
                        <label className="font-medium">Output</label>
                        {output && (
                            <button onClick={copyToClipboard} className="btn-secondary">
                                Copy
                            </button>
                        )}
                    </div>
                    {error ? (
                        <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg">
                            <p className="font-semibold">Error:</p>
                            <p>{error}</p>
                        </div>
                    ) : (
                        <textarea
                            value={output}
                            readOnly
                            placeholder="Result will appear here..."
                            className="w-full h-48 p-4 border border-gray-300 rounded-lg font-mono text-sm bg-gray-50"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
